(function($){

$.fn.accordion = function(options){
    if(!this || this.length < 1){ return this; }
    initialize(this, options);
};

function initialize(obj, options){
    var opts = $.extend({}, $.fn.accordion.defaults, options);

    obj.each(function(){
        var $this = $(this);
        saveOpts($this, opts);

        if(opts.bind == 'mouseenter'){
            $this.on('mouseenter', function(e){ e.preventDefault(); toggle($this, opts); });
        }
        if(opts.bind == 'mouseover'){
            $this.on('mouseover', function(e){ e.preventDefault(); toggle($this, opts); });
        }
        if(opts.bind == 'click'){
            $this.on('click', function(e){ e.preventDefault(); toggle($this, opts); });
        }
        if(opts.bind == 'dblclick'){
            $this.on('dblclick', function(e){ e.preventDefault(); toggle($this, opts); });
        }

        var id = $this.attr('id');

        if(id != opts.defaultOpen){
            $this.addClass(opts.cssClose);
            opts.loadClose($this, opts);
        } else {
            $this.addClass(opts.cssOpen);
            opts.loadOpen($this, opts);
        }
    });

    return obj;
};

function loadOpts($this){
    return $this.data('accordion-opts');
}

function saveOpts($this, opts){
    return $this.data('accordion-opts', opts);
}

/* ❌ Removed auto close of other accordions */
function open($this, opts){
    $this.removeClass(opts.cssClose).addClass(opts.cssOpen);
    opts.animateOpen($this, opts);
}

function closeSingle($this, opts){
    $this.removeClass(opts.cssOpen).addClass(opts.cssClose);
    opts.animateClose($this, opts);
}

/* ✅ Toggle only clicked one */
function toggle($this, opts){
    if($this.hasClass(opts.cssOpen)){
        closeSingle($this, opts);
        return false;
    } else {
        open($this, opts);
        return false;
    }
}

$.fn.accordion.defaults = {
    cssClose: 'accordion-close',
    cssOpen: 'accordion-open',
    defaultOpen: '',
    speed: 'slow',
    bind: 'click',
    animateOpen: function(elem, opts){
        elem.next().stop(true,true).slideDown(opts.speed);
    },
    animateClose: function(elem, opts){
        elem.next().stop(true,true).slideUp(opts.speed);
    },
    loadOpen: function(elem, opts){
        elem.next().show();
    },
    loadClose: function(elem, opts){
        elem.next().hide();
    }
};

})(jQuery);